var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.9995C2.99993 10.7085 3.06333 10.4211 3.18579 10.1572C3.30824 9.89329 3.4868 9.65928 3.709 9.47148L10.709 3.47248C11.07 3.16739 11.5274 3 12 3C12.4726 3 12.93 3.16739 13.291 3.47248L20.291 9.47148C20.5132 9.65928 20.6918 9.89329 20.8142 10.1572C20.9367 10.4211 21.0001 10.7085 21 10.9995V19.9995C21 20.5299 20.7893 21.0386 20.4142 21.4137C20.0391 21.7888 19.5304 21.9995 19 21.9995H5C4.46957 21.9995 3.96086 21.7888 3.58579 21.4137C3.21071 21.0386 3 20.5299 3 19.9995V10.9995Z",
    fill: "#FFB98A",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22V14C15 13.7348 14.8946 13.4804 14.7071 13.2929C14.5196 13.1054 14.2652 13 14 13H10C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14V22",
    fill: "#FF6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22V14C15 13.7348 14.8946 13.4804 14.7071 13.2929C14.5196 13.1054 14.2652 13 14 13H10C9.73478 13 9.48043 13.1054 9.29289 13.2929C9.10536 13.4804 9 13.7348 9 14V22H15Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ad27264490c7aba6b8dc521866473028.svg";
export { ForwardRef as ReactComponent };